module.exports = __webpack_public_path__ + "img/com.electrolux.service.wifistrength.dev.uat.prod.65a6a939.webp";